import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import useLocalization from 'hooks/useLocalization'

const AddRole = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'crm_settings',
    dict: {
      name: 'Name',
      add_funnels: 'Add funnels',
      funnel_name: 'Funnel name',
      add_field: 'Add a field',
      field_name: 'Field name',
      field_type: 'Field type',
      boolean: 'Boolean',
      text: 'Text',
    },
  })

  return (
    <FormField>
      <FormLabel isRequired>{translate.name}:</FormLabel>
      <FormInput isError={check('name')}>
        <input
          name='name'
          onChange={(e) => changeValues(e.target.value, 'name')}
          placeholder={translate.name}
          value={modalValue.name || ''}
        />
      </FormInput>
    </FormField>
  )
}

export default observer(AddRole)
